import urlRoute from '../../common/service/urlRoute';
import CONSTANTS from '../../common/constants/constants';

export const API = {
  STOCK_LIST_PATH: urlRoute.joinUrl(CONSTANTS.SPC_API_URL, '/stock/list'),
  STOCK_VALIDATE_SELECTIONS: urlRoute.joinUrl(CONSTANTS.BASKET_API_URL, '/validate-basket-selections'),
};
